import { useState, useEffect } from 'react'
import useAppStatusStore from '@/store/app-status-store.js'

const useCheckActiveApp = () => {
  const [isActive, setIsActive] = useState(true)

  useEffect(() => {
    const checkMinimizedOrHidden = () => {
      // Check if the browser is minimized or the tab is not visible
      const isMinimized = window.outerWidth === 0 || window.outerHeight === 0
      const isHidden = document.hidden
      setIsActive(!isMinimized && !isHidden)
      useAppStatusStore.getState().setIsVisible(!isMinimized && !isHidden)
    }

    // Handle visibility change (switching tabs)
    const handleVisibilityChange = () => {
      checkMinimizedOrHidden()
    }

    // Handle resize (minimize/maximize)
    const handleResize = () => {
      checkMinimizedOrHidden()
    }

    // Add event listeners
    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('resize', handleResize)

    // Initial check
    checkMinimizedOrHidden()

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isActive
}

export default useCheckActiveApp
